import { Shield } from 'lucide-react';
import * as React from 'react';

import { TypographyMuted } from '@/components/ui/typography';

import { RegisterForm } from '@/pages/unauthenticated/auth/register/form/register-form';

export function RegisterHero() {
  return (
    <div className="mx-auto max-w-7xl px-2 py-0 lg:flex lg:items-center lg:gap-x-10 lg:px-8 lg:py-40">
      <div className="mx-auto max-w-xl lg:mx-0 lg:flex-auto">
        <h1 className="lg:mt-10 text-5xl font-black tracking-tight text-pretty sm:text-7xl max-w-[11ch]">
          Start your free{' '}
          <span className="text-primary italic relative">FlagSync</span> trial
        </h1>
        <TypographyMuted className="inline-flex items-center gap-2 mt-6">
          <Shield className="size-4" />
          <span>No credit card required • Free 14-day trial</span>
        </TypographyMuted>
      </div>
      <div className="mt-8 lg:mt-0 lg:shrink-0 lg:grow">
        <RegisterForm />
      </div>
    </div>
  );
}
